import React from 'react';
import { Button, Space } from 'antd';
import Modal from '../../main/components/Modal';
import GlobalContext from '../../main/utils/GlobalContext';

const ModalDeleteConfirmation = ({
  visible,
  confirmationTitle,
  onClose,
  onDelete,
  confirmationText,
}) => {
  const { locales } = React.useContext(GlobalContext);
  return (
    <Modal isOpen={visible} onClose={onClose} title={confirmationTitle}>
      <Space>
        <Button onClick={onClose}>{locales.common.cancel}</Button>
        <Button type="primary" danger onClick={onDelete}>
          {confirmationText || locales.common.deleteText}
        </Button>
      </Space>
    </Modal>
  );
};

export default ModalDeleteConfirmation;
